import type { API } from 'api/config/types';
import { MoveListComponent } from 'components/move-list/config/types';

/**
 * Check if the variations popover should be opened.
 */
export default function shouldOpenVariationsPopover(api: API.ExtendedAPI): boolean {
  const variationVisibility: MoveListComponent.VariationVisibility | undefined = api['move-list']
    ?.getMoveList()
    ?.getVariationVisibility();
  if (!variationVisibility || variationVisibility === MoveListComponent.VariationVisibility.None) {
    // hiding variations, so no popover
    return false;
  }

  const selectedNode = api.getSelectedNode();
  if (!selectedNode) {
    return false;
  }

  if (
    variationVisibility === MoveListComponent.VariationVisibility.Active &&
    selectedNode.ids.line === 0
  ) {
    // if "active" variation visibility,
    // only show popover when inside a variation line since variations wont be visible on the next main line node
    return false;
  }

  const rawLines = api.getRawLines();
  const nextNode = rawLines[selectedNode.ids.line][selectedNode.ids.move + 1];

  // only show popover if the next node has child lines
  // and those lines are not just "empty" continuations (i.e. 1. e4 e5 (1... e5))
  return (nextNode?.lines ?? []).some((lineIndex) => {
    const variation = rawLines[lineIndex];
    if (!variation[0]) {
      return false;
    }

    return !variation[0].isContinuation || rawLines[lineIndex].length > 1;
  });
}
